import { SVGAttributes, SVGProps } from "react";

const CardHero1MobUnderline = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 256 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.00024 8C55.6497 5.31152 200.912 9.12266 249 7.11841"
        stroke="#CFB2FF"
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CardHero1MobUnderline;
